module.exports = __webpack_public_path__ + "static/media/twitter.08eb1ba5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/social/twitter.svg
// module id = 136
// module chunks = 0